// import PropTypes from 'prop-types';
import styles from './Chip.module.scss';
import classNames from 'classnames';

const Chip = ({ title, id, onClick = () => { }, slug, selected = false }) => {

    if (id === undefined) {
        return null
    }

    return (
        <label
            htmlFor={`chip_${id}_${slug}`}
            className={classNames(styles['Chip'], { [styles['Chip--Selected']]: selected })}>
            <input
                id={`chip_${id}_${slug}`}
                type="checkbox"
                defaultChecked={selected}
                onChange={() => onClick(id)}
                className={styles['Chip__Check']}
            >
            </input>

            {title}
        </label>
    );
};

Chip.propTypes = {};

export default Chip;
